import {
  ACTION_LOAD_FAVICON__REQUEST,
  ACTION_LOAD_FAVICON__SUCCESS,
  ACTION_LOAD_FAVICON__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_FAVICON__REQUEST:
    case ACTION_LOAD_FAVICON__SUCCESS:
      return null;

    case ACTION_LOAD_FAVICON__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
